/* eslint-disable react-hooks/exhaustive-deps */
import {
	Avatar,
	Box,
	Divider,
	Flex,
	Heading,
	HStack,
	Icon,
	IconButton,
	Image,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
	Spacer,
	Text,
	Tooltip,
	useDisclosure,
	useOutsideClick,
	VStack,
	InputGroup,
	InputRightElement,
	Spinner,
	Input,
	Center,
} from '@chakra-ui/react'
import QRCode from 'qrcode.react'
import ReactCountdownClock from 'react-countdown-clock'
import React, { useCallback, useEffect, useState, useRef } from 'react'
import { BiCalendarExclamation, BiDownload } from 'react-icons/bi'
import { HiOutlineOfficeBuilding } from 'react-icons/hi'
import { debounce } from 'lodash'
import {
	MdPeople,
	MdPowerSettingsNew,
	MdAccountCircle,
	MdChat,
} from 'react-icons/md'
import { AiOutlineBarChart } from 'react-icons/ai'
import { BsSearch } from 'react-icons/bs'
import { Ri24HoursLine } from 'react-icons/ri'
import { GoGraph } from 'react-icons/go'
import { MdLocationCity, MdOutlineSearch } from 'react-icons/md'
import { useHistory } from 'react-router'
import GreneLogo from '../../assets/images/grene-logo.png'

import { useAuthContext } from '../../context/auth.context'
import { useLanguageContext } from '../../context/locale.context'
import { loadAwsFile } from '../../utils/aws.util'
import { useLoadOrgConfigList } from '../../hooks/activity.hooks'
import {
	encryptData,
	getLocalAuthDetails,
	timeAgo,
	timelineDateFormatShort,
} from '../../utils/common.util'
import Broadcast from './brodcast'
import DownloadTemplates from './downloadTemplates'
import PushNotificationHandler from './pushNotificationHandler'
import { useSetPassword, useLoadLanguageList } from '../../hooks/asset.hooks'
import { useSharedContext } from '../../context/shared.context'
import { loginConst, localizationConst } from './../../utils/action.constant'
import { useGetTranslations } from './../../hooks/dashboard.hooks'
import { toast } from 'react-toastify'
import {
	dataLayerTagManager,
	sectionDetailedTrack,
} from '../../containers/repository/repo.utils'
import { GA_CATEGORY_NAVBAR } from './../../containers/repository/repo.utils'
import ReactSelect from 'react-select'
import './style.css'
import OrganizationMenu from './organization/orgMenu'
import CountdownTimer from '../../components/countdown-timer'
import ButtonCTA from './../globalComponents/button/index'
import { getCurrentDateISTWidgetDash } from '../../utils/date.utils'
import {
	useLoadActivityListV1,
	useLoadActivityListV2,
	useLoadFilterActivityList,
	useLoadFocusActivityList,
	useLoadChildOrderActivity,
} from '../../hooks/activity.hooks'
import SVGIcon from './../../assets/svgIcons/index'
import WorkStatus from './WorkStatus/index'

export default function Navbar({
	handleLogout,
	onVideoPlayListner,
	triggerLogoutPopup,
	sessionTime,
	showSessionTimer,
}) {
	const {
		state: { authData },
	} = useAuthContext()
	const { state } = useSharedContext()
	const ref = useRef(null)
	const {
		state: { locale, selectedLanguage },
		dispatch: languageDispatch,
	} = useLanguageContext()
	const { mutate } = useSetPassword()
	const { mutate: loadOrgConfig } = useLoadOrgConfigList()
	const { mutate: loadLanguageTexts } = useGetTranslations()
	const { mutate: loadLanguagesList } = useLoadLanguageList()
	const [searchQuery, setSearchQuery] = useState('')
	const [selectedSort, setselectedSort] = useState({})
	const [selectedFilter, setSelectedFilter] = useState({})
	const [selectedQueue, setSelectedQueue] = useState({})
	const [selectedStatus, setSelectedStatus] = useState({})
	const { mutate: activityListV1Mutate, isLoading: loadingActivityList } =
		useLoadActivityListV1()

	const { organization_flag_enable_tag } = authData
	const [data, setdata] = useState({})
	const user = authData
	const {
		organization_file_templates,
		organization_image_path,
		asset_flag_arp_settings_enabled,
	} = authData
	const history = useHistory()
	const { isOpen, onClose, onOpen } = useDisclosure()

	const [managerDetailsParam, setManagerDetailsParam] = useState({
		manager_id: authData.asset_id,
	})
	const [imageData, setImageData] = useState(null)
	const [orgRedirectionData, setorgRedirectionData] = useState([])
	const [profileImageData, setProfileImageData] = useState(null)
	const [languages, setLanguages] = useState([])
	const [ispopup, setIspopup] = useState(false)
	const [isActive, setIsActive] = useState(false)
	const languageDropdownValues = {
		English: { label: 'ENG' },
		Hindi: { label: 'HIN' },
		Japanese: { label: 'JAP' },
		Telugu: { label: 'TEL' },
	}

	useOutsideClick({
		ref: ref,
		handler: () => {
			setIsActive(false)
		},
	})

	const handleClick = () => {
		setIsActive(true)
	}
	const openWebApp = () => {
		const authPayload = btoa(
			JSON.stringify({
				accountId: authData.account_id,
				assetId: authData.asset_id,
				assetName: authData.operating_asset_first_name,
				countryCode: `+${authData.asset_phone_country_code}`,
				email: authData.asset_email_id,
				encToken: authData.asset_encryption_token_id,
				key: 'web',
				loggedDeviceOs: 'Chrome',
				mobile: authData.asset_phone_number,
				mode: '101',
				operatingAssetId: authData.operating_asset_id,
				organizationId: authData.organization_id,
				workforceId: authData.workforce_id,
				assetImagePath: authData.asset_image_path,
			})
		)
		const encryptedLoginData = encryptData(authPayload)
		const tonyWebUrl = `${process.env.REACT_APP_OLD_WEB_URL}#/login/${encryptedLoginData}`
		window.open(tonyWebUrl, '_blank')
	}

	const setSelectedLanguage = selectedLanguage => {
		loadLanguageTexts(
			{
				asset_id: authData.asset_id,
				asset_token_auth: authData.asset_token_auth,
				language_id: selectedLanguage.value,
				limit_value: 600,
				start_from: 0,
			},
			{
				onSuccess: data => {
					languageDispatch({
						type: localizationConst.SET_SELECTED_LANGUAGE,
						selectedLanguage,
						data,
					})
				},
				onError: err => {
					toast({
						title: `${err.message}`,
						position: `top-right`,
						isClosable: true,
						status: 'error',
					})
				},
			}
		)
	}
	const onSuccess = (res, isChild = false, pagestart = 0) => {
		// setIsLoading(false)
		// setIsBtnLoading(false)
		// if (
		//   !!searchQuery ||
		//   !data ||
		//   !Object.keys(data).length ||
		//   (isChild && pagestart === 0) ||
		//   (isRefresh && pagestart === 0)
		// ) {
		if (pagestart === 0) {
			setdata(res)
		} else if (!!data && !!res) {
			const { list, ...rest } = res
			setdata({
				...rest,
				list: [...data.list, ...list],
			})
		}
	}
	const onError = err => {
		// setIsLoading(false)
		// setIsBtnLoading(false)
	}
	const loadActivity = ({
		start = 0,
		searchQuery = '',

		selectedStatus,
	}) => {
		let params = {}
		if (!!selectedStatus && Object.keys(selectedStatus).length > 0) {
			if (organization_flag_enable_tag === 1 && selectedStatus.tag_id === 0) {
				params = {
					flag: 10,
					tag_id: selectedStatus.tag_id,
					tag_type_id: selectedStatus.tag_type_id,
					activity_status_id: selectedStatus.activity_status_id,
					activity_type_id: selectedStatus.activity_type_id,
					activity_type_category_id: 0,
				}
			} else {
				params = {
					flag: 10,
					activity_status_id: selectedStatus.activity_status_id,
					activity_type_id: selectedStatus.activity_type_id,
					activity_type_category_id: selectedStatus.activity_type_category_id,
				}
			}
		}
		activityListV1Mutate(
			{
				sort_flag: selectedSort.value || 0,
				flag: selectedQueue.flag || 0,
				queue_id: 0,
				is_active: !!searchQuery ? 1 : 0,
				is_due: 0,
				current_datetime: '',
				is_unread: 0,
				is_search: !!searchQuery ? 1 : 0,
				search_string: searchQuery || '',
				status_type_id: 0,
				page_start: start,
				page_limit: 30,
				...params,
			},
			{
				onSuccess: res => {
					onSuccess(res, false, start)
				},
				onError,
			}
		)
	}
	// useEffect(() => {
	//   if (!!organization_image_path) {
	//     loadAwsFile(organization_image_path, d => {
	//       let data = 'data:' + d.type + ';base64,' + d.data;
	//       setImageData(data);
	//     });
	//   }
	// }, [organization_image_path]);
	useEffect(() => {
		setTimeout(() => {
			if (!!authData.asset_image_path) {
				loadAwsFile(authData.asset_image_path, d => {
					let data = 'data:' + d.type + ';base64,' + d.data
					setProfileImageData(data)
				})
			}
		}, 1000)
	}, [authData.asset_image_path, profileImageData])

	useEffect(() => {
		setTimeout(() => {
			if (!!organization_image_path) {
				loadAwsFile(organization_image_path, d => {
					let data = 'data:' + d.type + ';base64,' + d.data
					setImageData(data)
				})
			}
		}, 1000)
	}, [organization_image_path, imageData])

	const contactDetail = () => {
		const {
			operating_asset_first_name,
			asset_first_name,
			asset_email_id,
			asset_phone_country_code,
			asset_phone_number,
			organization_name,
		} = authData

		if (!!operating_asset_first_name) {
			// return `MECARD:N:${operating_asset_first_name.trim().split(' ').join()};NICKNAME:${asset_first_name};DPT:${workforce_name};TEL:+${asset_phone_country_code}${asset_phone_number};EMAIL:${asset_email_id};;`;
			return `BEGIN:VCARD\nVERSION:3.0\nN:${operating_asset_first_name}\nORG:${organization_name}\nTITLE:${asset_first_name}\nTEL:+${asset_phone_country_code}${asset_phone_number}\nEMAIL:${asset_email_id}\nEND:VCARD`
			// return `MECARD:N:${operating_asset_first_name.trim().split(' ').join()};NICKNAME:${asset_first_name};DPT:${workforce_name};TEL:+${asset_phone_country_code}${asset_phone_number};EMAIL:${asset_email_id};;`;
		}
		return ''
	}

	useEffect(() => {
		if (Object.keys(locale).length === 0)
			setSelectedLanguage({ label: 'English', value: 1 })
	}, [locale])

	useEffect(() => {
		loadOrgConfig(
			{},
			{
				onSuccess: async data => {
					if (
						JSON.parse(data[0]?.organization_enterprise_feature_data)?.feature
							?.org_redirections
					) {
						setorgRedirectionData(
							JSON.parse(data[0].organization_enterprise_feature_data).feature
								.org_redirections
						)
					}
				},
				onError: async err => {
					console.log(err, 'err')
				},
			}
		)

		loadLanguagesList(
			{},
			{
				onSuccess: async data => {
					if (!!data?.length) {
						setLanguages(data)
					}
				},
			}
		)
	}, [])
	const onDebounceSearch = useCallback(
		debounce(e => {
			setdata(null)
			loadActivity({
				start: 0,
				searchQuery: e,
			})
			setSearchQuery(e)
		}, 500),
		[]
	)
	return (
		<>
			{!!isOpen ? (
				<DownloadTemplates isOpen={isOpen} onClose={onClose} />
			) : null}

			<Flex
				width={'100%'}
				position='fixed'
				top='0'
				zIndex='10'
				height='70px'
				bg='brand.700'
				alignItems='center'
				pl='2.5rem'
				pr='4rem'
			>
				{/* <Flex
          flexDir="column"
          justifyContent="center"
          alignItems="flex-start"
          ml={2}
        >
          <HStack>
            <Menu>
              <MenuButton>
                <Avatar
                  size="md"
                  name={authData?.operating_asset_first_name}
                  bgColor="green.500"
                  color="white"
                  src={profileImageData}
                />
              </MenuButton>
              <MenuList maxWidth={'450px'}>
                <Box px={3}>
                  <Box>
                    <HStack alignItems="center" my={2}>
                      <Box
                        padding={2}
                        rounded="lg"
                        h="100px"
                        w="100px"
                        bg="white"
                        boxShadow="sm"
                      >
                        <QRCode
                          style={{
                            height: '100%',
                            width: '100%',
                          }}
                          level="Q"
                          value={contactDetail()}
                        />
                      </Box>
                      <VStack
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        flex={1}
                      >
                        <Heading
                          m={0}
                          size="md"
                          fontSize="sm"
                          fontWeight="500"
                          textTransform="capitalize"
                          color="black"
                        >
                          {user.operating_asset_first_name}
                        </Heading>
                        <Text
                          style={{ margin: 0 }}
                          fontSize="sm"
                          textTransform="capitalize"
                        >
                          {user.asset_type_name}
                        </Text>
                        {user.asset_email_id && (
                          <Text
                            style={{ margin: 0 }}
                            fontSize="xs"
                            textTransform="capitalize"
                          >
                            {user.asset_email_id}
                          </Text>
                        )}
                        {user.asset_phone_number && (
                          <Text
                            style={{ margin: 0 }}
                            fontSize="xs"
                            textTransform="capitalize"
                          >
                            + {user.asset_phone_country_code}{' '}
                            {user.asset_phone_number}
                          </Text>
                        )}
                      </VStack>
                    </HStack>
                  </Box>
                  <Divider />
                  <VStack alignItems="flex-start" spacing={1} pt={2}>
                    {!!user.workforce_name && (
                      <Text my={0} fontSize="xs" textTransform="capitalize">
                        <Text my={0} as="span" fontWeight="600" mr={1}>
                          {locale['Segment']} :
                        </Text>
                        {user.workforce_name}
                      </Text>
                    )}
                    {user.asset_created_datetime ? (
                      <Text>
                        <Text as="span" className="w-500">
                          {locale['Created at']} :{' '}
                        </Text>
                        {timelineDateFormatShort(user.asset_created_datetime)}
                      </Text>
                    ) : null}
                    {user.account_name && (
                      <Text my={0} fontSize="xs" textTransform="capitalize">
                        <Text my={0} as="span" fontWeight="600" mr={1}>
                          {locale['Circle']} :
                        </Text>
                        {user.account_name}
                      </Text>
                    )}
                    {!!user.asset_last_seen_datetime ? (
                      <Text my={0} fontSize="xs" textTransform="capitalize">
                        <Text as="span" fontWeight="600">
                          {locale['Last Seen']} :{' '}
                        </Text>
                        {timeAgo(user.asset_last_seen_datetime)}
                      </Text>
                    ) : null}

                    {!!user.asset_last_location_address ? (
                      <Text my={0} fontSize="xs" textTransform="capitalize">
                        <Text as="span" fontWeight="600">
                          {locale['Last Location']} :
                        </Text>{' '}
                        {user.asset_last_location_address}
                      </Text>
                    ) : null}
                  </VStack>
                </Box>
                <Divider />
                <MenuItem
                  icon={<Icon as={MdPeople} w={5} h={5} color="brand.800" />}
                  onClick={() => history.push('/team')}
                >
                  {locale['Team']}
                </MenuItem>
                {authData?.organization_id === 868 ||
                authData?.organization_flag_enable_leave ? (
                  <MenuItem
                    icon={
                      <Icon
                        as={BiCalendarExclamation}
                        w={5}
                        h={5}
                        color="brand.800"
                      />
                    }
                    onClick={() => history.push('/leave')}
                  >
                    {locale['Unavailabilty']}
                  </MenuItem>
                ) : null}
                <MenuItem
                  icon={
                    <Icon as={MdAccountCircle} w={5} h={5} color="brand.800" />
                  }
                  onClick={() => {
                    setManagerDetailsParam({ manager_id: authData.asset_id })
                    history.push('/profile')
                  }}
                >
                  {locale['Profile']}
                </MenuItem>
                {asset_flag_arp_settings_enabled === 1 && (
                  <MenuItem
                    icon={
                      <Icon as={Ri24HoursLine} w={5} h={5} color="brand.800" />
                    }
                    onClick={() => history.push('/workhours')}
                  >
                    {locale['Work Hours']}
                  </MenuItem>
                )}
                <MenuItem
                  icon={
                    <Icon
                      as={AiOutlineBarChart}
                      w={5}
                      h={5}
                      color="brand.800"
                    />
                  }
                  onClick={() => history.push('/arpscores')}
                >
                  {locale['ARP Scores']}
                </MenuItem>
                <MenuItem
                  icon={<Icon as={MdChat} w={5} h={5} color="brand.800" />}
                  onClick={() => {
                    sectionDetailedTrack({
                      category: GA_CATEGORY_NAVBAR,
                      action: 'Chat',
                      label: locale['Open Chat'],
                    })
                    history.push('./chats')
                  }}
                >
                  {locale['Chat']}
                </MenuItem>
                {user?.asset_type_flag_enable_gamification === 1 && (
                  <MenuItem
                    icon={<Icon as={GoGraph} w={5} h={5} color="brand.800" />}
                    onClick={() => {
                      sectionDetailedTrack({
                        category: GA_CATEGORY_NAVBAR,
                        action: 'GScore',
                        label: locale['Open GScore'],
                      })
                      history.push('./gscore')
                    }}
                  >
                    {locale['GScore']}
                  </MenuItem>
                )}
                <MenuItem
                  icon={
                    <Icon as={MdLocationCity} w={5} h={5} color="brand.800" />
                  }
                  onClick={() => {
                    sectionDetailedTrack({
                      category: GA_CATEGORY_NAVBAR,
                      action: 'WorkStatus',
                      label: locale['Open Work Status'],
                    })
                    setManagerDetailsParam({ manager_id: authData.asset_id })
                    history.push('./workstatus')
                  }}
                >
                  {locale['Work Status']}
                </MenuItem>
                <MenuItem
                  icon={
                    <Icon
                      as={HiOutlineOfficeBuilding}
                      w={5}
                      h={5}
                      color="brand.800"
                    />
                  }
                  onClick={() => {
                    sectionDetailedTrack({
                      category: GA_CATEGORY_NAVBAR,
                      action: 'Accounts',
                      label: locale['Open Accounts'],
                    })
                    history.push('./organizations')
                  }}
                >
                  {locale['Accounts']}
                </MenuItem>
              </MenuList>
            </Menu>
            <Box>
              <HStack spacing={1}>
                <Heading as="h5" size="md" fontWeight="400">
                  {authData?.operating_asset_first_name || ''}
                </Heading>
              </HStack>
              <Text isTruncated fontSize="sm" mt={0}>
                {authData?.account_name} - {authData?.workforce_name}
              </Text>
            </Box>
          </HStack>
        </Flex> */}
				<Tooltip
					label='ID Card'
					color='black'
					bg='#F5F5F5'
					boxShadow='0px 6px 20px rgba(24, 39, 75, 0.2), 0px 10px 32px rgba(24, 39, 75, 0.1)'
					isDisabled={history?.location?.pathname === '/idcard'}
				>
					<IconButton
						variant='unstyled'
						aria-label='Go to IDCard Page'
						icon={
							<SVGIcon
								iconName='BackArrowSvg'
								svgProps={{
									width: '24',
									height: '24',
									viewBox: '0 0 24 24',
								}}
								pathProps={{ fill: 'white' }}
							/>
						}
						onClick={() => {
							history.push('/idcard')
						}}
						disabled={history?.location?.pathname === '/idcard'}
					/>
				</Tooltip>
				{/* <Image src={greneOrgIcon} maxW='2.25rem' maxH='2.25rem' /> */}
				<SVGIcon
					iconName='NavbarGreneLogoSvg'
					svgProps={{
						width: '38',
						height: '36',
						viewBox: '0 0 38 36',
					}}
					// pathProps={{ fill: 'white' }}
				/>
				<Spacer />
				<Flex h={'100%'}>
					<HStack spacing={4}>
						{/* <ButtonCTA
              variant="outline"
              size="sm"
              borderRadius="full"
              boxShadow="md"
              colorScheme="green"
              onClick={() => history.push('/ganttChart')}
            >
              GanttChart
            </ButtonCTA> */}
						{/* TODO: Use multiple icons base on notifications */}
						{/* <ButtonCTA
              variant="outline"
              size="sm"
              borderRadius="full"
              boxShadow="md"
              colorScheme="green"
              onClick={() => {
                openWebApp();
              }}
            >
              OLD Web
            </ButtonCTA> */}
						{/* <Box position='relative' ref={ref}>
							<InputGroup width={'310px'}>
								<Input
									placeholder={locale['Smart search']}
									_placeholder={
										isActive
											? {
													color: 'brand.700',
													opacity: '0.6',
											  }
											: {}
									}
									borderRadius='full'
									border='1px solid rgba(255, 255, 255,0.5)'
									bg={isActive ? '#FFFFFF' : '#009B76'}
									color={isActive ? 'gray.400' : '#80CDBB'}
									boxShadow={'none'}
									value={searchQuery}
									onClick={handleClick}
									onChange={e => {
										dataLayerTagManager('button_click', {
											viewName: 'Home',
											buttonName: 'Smart Search',
										})
										setSearchQuery(e.target.value)
										onDebounceSearch(e.target.value)
									}}
									_focus={{
										border: '1px solid rgba(255, 255, 255,0.5)',
										boxShadow: 'none',
									}}
								/>
								<InputRightElement
									children={<BsSearch color={isActive ? 'green' : '#FFFFFF'} />}
								/>
							</InputGroup>
							{isActive && searchQuery?.length >= 1 && (
								<Box
									maxH='40vh'
									overflowY={'auto'}
									borderRadius='4'
									boxShadow='0px 6px 14px rgba(24, 39, 75, 0.12), 0px 10px 32px rgba(24, 39, 75, 0.1)'
									_focus={{
										border: 'none',
										boxShadow: 'none',
									}}
									bg='#FFFFFF'
									borderBottomRightRadius='20px'
									borderBottomLeftRadius='20px'
									border='0'
									position='absolute'
									top='auto'
									mt='5px'
									w='100%'
								>
									{data?.list?.map(listItem => (
										<Text
											p='3'
											pl='15px'
											color={'brand.700'}
											fontSize='14px'
											fontWeight={500}
											borderBottom={'1px solid #E1E1E1'}
										>
											{listItem.activity_title}
										</Text>
									))}
									{data?.list?.length === 0 && (
										<Text
											p='3'
											pl='15px'
											color={'brand.700'}
											fontSize='14px'
											fontWeight={500}
										>
											{'No Data found!'}
										</Text>
									)}
									{loadingActivityList && (
										<Center p={2}>
											<Spinner size='md' color='brand.700' />
										</Center>
									)}
								</Box>
							)}
						</Box> */}
						{orgRedirectionData.length
							? orgRedirectionData?.map(
									(item, i) =>
										item?.flag_enable && (
											<ButtonCTA
												variant='navbarButton'
												fontWeight='500'
												fontSize='0.875rem'
												lineHeight='1.1rem'
												key={i}
												disabled={!item.flag_enable}
												onClick={() => {
													dataLayerTagManager('button_click', {
														viewName: 'Navbar',
														buttonName: item.display_name,
													})
													window.open(item.display_icon, '_blank')
												}}
											>
												{item.display_name}
											</ButtonCTA>
										)
							  )
							: null}

						<PushNotificationHandler handleLogout={handleLogout} />
						{/*{!!organization_file_templates &&
            !!organization_file_templates.length ? (
              <IconButton
                onClick={() => {
                  sectionDetailedTrack({
                    category: GA_CATEGORY_NAVBAR,
                    action: 'Download Templates',
                    label: 'Open Download Templates',
                  })
                  dataLayerTagManager('button_click', {
                    viewName: 'Navbar',
                    buttonName: 'Download Templates',
                  })
                  onOpen()
                }}
                my={2}
                icon={<Icon as={BiDownload} h={6} w={6} />}
                color="green.400"
                _focus={{
                  color: 'green.400',
                }}
                _hover={{
                  color: 'white',
                  bg: 'green.400',
                }}
                _active={{
                  color: 'white',
                  bg: 'green.400',
                }}
              />
            ) : null} */}
						<Broadcast />
						{/* {!!imageData ? (
              <Image
                boxSize="60px"
                objectFit="contain"
                alt="company logo"
                fallbackSrc={GreneLogo}
                src={imageData}
              />
            ) : (
              <Image
                boxSize="50px"
                objectFit="contain"
                alt="company logo"
                fallbackSrc={GreneLogo}
                src={
                  'https://stagingweb.greneos.com/static/media/logo.336da18f.png'
                }
              />
            )} */}
						<OrganizationMenu orgImage={imageData} />
						<WorkStatus onVideoPlayListner={onVideoPlayListner} />

						{/* <Box
              boxShadow="md"
              width="70px"
              position="relative"
              border={!!showSessionTimer ? '1px solid red' : ''}
              bg="#000"
            >
              <video
                width="100%"
                height="100%"
                autoPlay
                muted
                onPlay={onVideoPlayListner}
                id="userCameraView"
              >
                {' '}
              </video>
              {!!showSessionTimer ? (
                <Box
                  className="timeout-popup"
                  style={{
                    top: '0px',
                    position: 'absolute',
                    zIndex: 100,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                  }}
                >
                  <ReactCountdownClock
                    style={{
                      margin: 'auto',
                    }}
                    seconds={sessionTime}
                    color="#fff"
                    alpha={0.9}
                    weight={4}
                    size={40}
                    onComplete={triggerLogoutPopup}
                  />
                </Box>
              ) : null}
            </Box> */}

						<ReactSelect
							isMulti={false}
							isSearchable={false}
							id={'language-select'}
							variant='outline'
							options={(languages || []).map(val => {
								return {
									label: val.language_name,
									value: val.language_id,
								}
							})}
							placeholder={locale['Select Language']}
							onChange={setSelectedLanguage}
							borderRadius='16px'
							color='#FFFFFF'
							value={languageDropdownValues[selectedLanguage.label]}
							size='sm'
							styles={{
								control: (baseStyles, state) => ({
									...baseStyles,
									backgroundColor: 'brand.700',
									border: '1px solid rgba(255, 255, 255,0.5)',
									borderRadius: '20px',
									'&:hover': {
										borderColor: 'rgba(255, 255, 255,0.5)',
									},
								}),
								container: baseStyles => ({
									...baseStyles,
								}),
								indicatorSeparator: baseStyles => ({
									...baseStyles,
									marginTop: '0px',
									marginBottom: '0px',
								}),
								singleValue: baseStyles => ({
									...baseStyles,
									color: '#FFFFFF',
								}),
								option: baseStyles => ({
									...baseStyles,
									textTransform: 'uppercase',
									letterSpacing: '2px',
								}),
								menu: baseStyles => ({
									...baseStyles,
									width: 'fit-content',
								}),
								valueContainer: baseStyles => ({
									...baseStyles,
									padding: '0px',
									justifyContent: 'center',
								}),
							}}
						/>

						<ButtonCTA
							fontWeight='normal'
							border={0}
							borderRadius={0}
							width={'90px'}
							leftIcon={
								<Icon
									color='#FFFFFF'
									as={MdPowerSettingsNew}
									w={8}
									h={8}
									mr='-5px'
								/>
							}
							color='#FFFFFF'
							bg='brand.700'
							// variant="outline"
							mr={2}
							p='0px'
							_active={{
								background: 'transparent',
							}}
							_hover={{ bg: 'brand.700' }}
							_focus={{
								boxShadow: 'none',
							}}
							onClick={e => {
								dataLayerTagManager('button_click', {
									viewName: 'Navbar',
									buttonName: 'Logout',
								})
								sectionDetailedTrack({
									category: GA_CATEGORY_NAVBAR,
									action: 'Download Templates',
									label: 'Open Download Templates',
								})
								handleLogout(e)
							}}
						>
							<Box
								display='flex'
								flexDir='column'
								alignItems='flex-start'
								justifyContent='space-evenly'
							>
								<Box
									color='#FFFFFF'
									fontSize='14px'
									fontWeight='500'
									textTransform='capitalize'
								>
									{locale['Log out'] || 'Log out'}
								</Box>

								{showSessionTimer ? (
									<Box color='#FFFFFF' fontSize='10px' fontWeight='500'>
										<CountdownTimer
											sessionTime={sessionTime}
											triggerLogoutPopup={triggerLogoutPopup}
										/>
									</Box>
								) : null}
							</Box>
						</ButtonCTA>
					</HStack>
				</Flex>
			</Flex>
		</>
	)
}
